import * as React from "react";
import { Loader } from "lib/components/Loader";
import { Modal, Button, Card } from "react-bootstrap";

import { getStore } from "../../store";
import { observer } from "mobx-react-lite";

export const DdlDialog = observer(() => {
  const store = getStore().ddl;
  const onClickClose = () => {
    store.selectedTable = "";
  };

  return (
    <Modal show={!!store.selectedTable} onHide={onClickClose}>
      <Modal.Header>
        <Modal.Title>{`DDL: ${store.selectedTable ?? ""}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Loader show={store.isLoading}>
          <Card bg="light">
            <Card.Body>
              <pre>
                <code>{store.isLoading ? "" : store.ddl}</code>
              </pre>
            </Card.Body>
          </Card>
        </Loader>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClickClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
});
